import React, {useState} from 'react';
import First from "../Main/Sections/First";
import {PlayMusic} from "../../ui/icons";

const Certification = () => {
    const [isOpen, setIsOpen] = useState(false);

    const styles = {
        img: {
            height: "100vh",
            backgroundImage: "linear-gradient(rgba(0, 0, 0, 0.61), rgba(0, 0, 0, 0.61)), url('./images/Main/Background.png')",
            backgroundSize: "cover",
            backgroundPosition: "center"
        },
        wrapper: {
            height: '100%',
            flexDirection: 'column',
        },
        mainText: {
            letterSpacing: '1.2px',
            lineHeight: '110%',
            fontWeight: 600,
        }
    };
    return (
        <div>
            <section>
                <div className='px-[20px] sm:px-[50px]' style={styles.img}>
                    <div style={styles.wrapper} className='flex items-center justify-between'>
                        <div></div>
                        <button onClick={() => setIsOpen(true)} className='cursor-pointer'>
                            <PlayMusic/>
                        </button>
                        <div className="w-full">
                            <h1 className="text-white text-left text-[54px] sm:text-4xl md:text-5xl lg:text-6xl pb-10">
                                Certification at the Online <br/> Arbitration Academy
                            </h1>
                        </div>
                    </div>
                </div>
                {isOpen && (
                    <div
                        className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-75 transition-opacity duration-300 ease-in-out">
                        <div
                            className="relative w-full max-w-2xl transform transition-all duration-300 ease-in-out scale-95">
                            <button className="absolute top-2 right-2 text-white text-2xl"
                                    onClick={() => setIsOpen(false)}>
                                &times;
                            </button>
                            <iframe
                                className="w-full h-[400px] sm:h-[500px]"
                                src="https://www.youtube.com/embed/YOUR_VIDEO_ID"
                                title="YouTube video player"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            ></iframe>
                        </div>
                    </div>
                )}
            </section>
            <div className='bg-[#0A1F44] text-white p-[50px_0_100px]'>
                <div className='max-w-[1080px] m-[0_auto] grid gap-10 justify-center p-4'>
                    <div className='grid gap-6'>
                        <h2 className='text-[24px] font-bold mb'>
                            Introduction
                        </h2>
                        <p className='text-[20px]'>
                            Obtaining a certificate from the Arbitration Academy confirms your knowledge and
                            qualifications in <br/> arbitration, mediation, and alternative dispute resolution. This document
                            will help you stand out <br/> br among legal professionals and enhance your professional reputation.
                        </p>
                    </div>
                    <div className='grid gap-6'>
                        <h2 className='text-[24px] font-bold mb'>
                            Scholarships for Training
                        </h2>
                        <p className='text-[20px]'>
                            The Academy awards up to <span className='text-[#8C1C1C] font-semibold'>3 scholarships</span> to the top students of each cohort. <br/>
                            The scholarship will cover the full cost of education or a part of it. <br/>
                            Selection is based on academic performance and resume evaluation.
                        </p>
                    </div>
                    <div className='grid gap-6'>
                        <h2 className='text-[24px] font-bold mb'>
                            Certification Requirements
                        </h2>
                        <p className='text-[20px]'>
                            To successfully obtain the certificate, students must:
                        </p>
                        <div className='bg-[#8C1C1C] rounded-xl'>
                            <div className='flex items-center gap-[20px] p-4 border-[#FFFFFF1A] border-b-[1px] border-solid'>
                                <span>
                                       <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="28" height="28" rx="14" fill="#0A1F44"/>
                                    <path d="M15.767 7.86364V19.5H13.6591V9.91477H13.5909L10.8693 11.6534V9.72159L13.7614 7.86364H15.767Z" fill="white"/>
                                </svg>
                                </span>

                                <p className='text-[20px] font-bold'>
                                    Complete all training modules.
                                </p>
                            </div>
                            <div className='flex gap-[20px] border-[#FFFFFF1A] border-b-[1px] border-solid p-4'>
                                <span>
                                          <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="28" height="28" rx="14" fill="#0A1F44"/>
                                    <path d="M10.0341 19.5V17.9773L14.0739 14.017C14.4602 13.6269 14.7822 13.2803 15.0398 12.9773C15.2973 12.6742 15.4905 12.3807 15.6193 12.0966C15.7481 11.8125 15.8125 11.5095 15.8125 11.1875C15.8125 10.8201 15.7292 10.5057 15.5625 10.2443C15.3958 9.97917 15.1667 9.77462 14.875 9.63068C14.5833 9.48674 14.2519 9.41477 13.8807 9.41477C13.4981 9.41477 13.1629 9.49432 12.875 9.65341C12.5871 9.80871 12.3636 10.0303 12.2045 10.3182C12.0492 10.6061 11.9716 10.9489 11.9716 11.3466H9.96591C9.96591 10.608 10.1345 9.96591 10.4716 9.42045C10.8087 8.875 11.2727 8.45265 11.8636 8.15341C12.4583 7.85417 13.1402 7.70455 13.9091 7.70455C14.6894 7.70455 15.375 7.85038 15.9659 8.14205C16.5568 8.43371 17.0152 8.83333 17.3409 9.34091C17.6705 9.84848 17.8352 10.428 17.8352 11.0795C17.8352 11.5152 17.7519 11.9432 17.5852 12.3636C17.4186 12.7841 17.125 13.25 16.7045 13.7614C16.2879 14.2727 15.7027 14.892 14.9489 15.6193L12.9432 17.6591V17.7386H18.0114V19.5H10.0341Z" fill="white"/>
                                </svg>
                                </span>
                                <div className='grid gap-4'>
                                    <h3 className='text-[20px] font-bold'>
                                        Submit a final essay.
                                    </h3>
                                    <p>
                                        The essay topic is determined by the Academy and provided to students at the end of the <br/> course. It should reflect the knowledge acquired during training and demonstrate the <br/>ability to apply it in arbitration practice.
                                    </p>
                                </div>
                            </div>
                            <div className='flex items-center  gap-[20px] p-4'>
                                <span>
                                     <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="28" height="28" rx="14" fill="#0A1F44"/>
                                    <path d="M13.7102 19.6591C12.892 19.6591 12.1648 19.5189 11.5284 19.2386C10.8958 18.9583 10.3958 18.5682 10.0284 18.0682C9.66098 17.5682 9.46591 16.9905 9.44318 16.3352H11.5795C11.5985 16.6496 11.7027 16.9242 11.892 17.1591C12.0814 17.3902 12.3333 17.5701 12.6477 17.6989C12.9621 17.8277 13.3144 17.892 13.7045 17.892C14.1212 17.892 14.4905 17.8201 14.8125 17.6761C15.1345 17.5284 15.3864 17.3239 15.5682 17.0625C15.75 16.8011 15.839 16.5 15.8352 16.1591C15.839 15.8068 15.7481 15.4962 15.5625 15.2273C15.3769 14.9583 15.108 14.7481 14.7557 14.5966C14.4072 14.4451 13.9867 14.3693 13.4943 14.3693H12.4659V12.7443H13.4943C13.8996 12.7443 14.2538 12.6742 14.5568 12.5341C14.8636 12.3939 15.1042 12.197 15.2784 11.9432C15.4527 11.6856 15.5379 11.3883 15.5341 11.0511C15.5379 10.7216 15.464 10.4356 15.3125 10.1932C15.1648 9.94697 14.9545 9.75568 14.6818 9.61932C14.4129 9.48295 14.0966 9.41477 13.733 9.41477C13.3769 9.41477 13.0473 9.47917 12.7443 9.60795C12.4413 9.73674 12.197 9.92045 12.0114 10.1591C11.8258 10.3939 11.7273 10.6742 11.7159 11H9.6875C9.70265 10.3485 9.89015 9.77652 10.25 9.28409C10.6136 8.78788 11.0985 8.40151 11.7045 8.125C12.3106 7.8447 12.9905 7.70455 13.7443 7.70455C14.5208 7.70455 15.1951 7.85038 15.767 8.14205C16.3428 8.42992 16.7879 8.81818 17.1023 9.30682C17.4167 9.79545 17.5739 10.3352 17.5739 10.9261C17.5777 11.5814 17.3845 12.1307 16.9943 12.5739C16.608 13.017 16.1004 13.3068 15.4716 13.4432V13.5341C16.2898 13.6477 16.9167 13.9508 17.3523 14.4432C17.7917 14.9318 18.0095 15.5398 18.0057 16.267C18.0057 16.9186 17.8201 17.5019 17.4489 18.017C17.0814 18.5284 16.5739 18.9299 15.9261 19.2216C15.2822 19.5133 14.5436 19.6591 13.7102 19.6591Z" fill="white"/>
                                </svg>
                                </span>
                                <div className='grid gap-4'>
                                    <h3 className='text-[20px] font-bold'>
                                        Receive a positive evaluation from instructors.
                                    </h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Certification;
